import { render, staticRenderFns } from "./BoardUpdate.vue?vue&type=template&id=406ea294&scoped=true&"
import script from "./BoardUpdate.vue?vue&type=script&lang=js&"
export * from "./BoardUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406ea294",
  null
  
)

export default component.exports